import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx'
import { Button } from '@material-ui/core';

type issmData = {
    "Request Number": string,
    "Organization Unit": string,
    "Application Name": string,
    "Number of Apps": string,
    "Date Requested": string | null,
    "Documentation Type": string,
    "ATD Expiration Date": string,
    "Application System Identifier Type": string,
    "Application System Identifier": string,
    "EMASS Identifier": string,
    "New Sign On Request Type": string,
    "IA Approval": string  
  }

export function ExportExcel(props:{data: issmData[], fileName: string}): JSX.Element {
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(props.data);
    function fitToColumn(data: issmData[]) {
        const columnWidths = []; 
        for (const property in data[0]) {      
            columnWidths.push({        
                wch: Math.max(
                    property ? property.toString().length : 0, 
                    20
                )       
            });   
        }    
        return columnWidths; 
    }
    worksheet['!cols'] = fitToColumn(props.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${props.fileName}.xlsx`);
  };

  return (
    <Button variant="outlined" style={{marginRight:"6px"}} size="small" onClick={exportToExcel} >
    Export
    </Button> 
  );
}